import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useCashBookTypesData() {
    const { data: cashBookTypes, isLoading: isLoadingCashBookTypes } = useQuery({
        queryKey: ['cash-book-types'],
        queryFn: async () => {
            const { data } = await axios.get(route('v2.transactions.cash-book-types'));
            return data;
        },
        placeholderData: [],
    });

    return {
        cashBookTypes,
        isLoadingCashBookTypes,
    };
}
